import { IStore } from "services/indexdb/interface/istore"
import { RdsId, SourceId } from "./indexes"

export const DeviceStore: IStore = {
    Name: 'Device',
    PrimaryField: 'deviceId',
    Indexes: [RdsId, SourceId],
    minimumVersion: 0
}
